import * as React from 'react';
import * as mrCap from '../../mrCapTypes';
import { className } from '../../util';

interface ProductFilterProps {
  filterBy?: string;
  filterOptions: mrCap.Product[];
  select: (group: string) => void;
}

export function ProductFilter({ filterBy, filterOptions, select }: ProductFilterProps) {

  let options = filterOptions.map(p => p.group);
  options = options.filter((v, i) => options.indexOf(v) === i);

  return (
    <div className='product-filter'>
      <i className='fas fa-sort-amount-down'></i>
      {options.map(option =>
        <FilterOption
          key={option}
          name={option}
          click={select}
          selected={filterBy === option} />)}
    </div>
  );
}

interface FilterOptionProps {
  name: string | null;
  selected: boolean;
  click: (name: any) => void;
}

function FilterOption({ name, selected, click }: FilterOptionProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    click(name);
  };

  const typeName = name;

  return (
    <a href={`#${typeName}`}
      className={className('product-filter-option', { selected })}
      onClick={handleClick}
      title={name ?? ''}>{name}</a>
  );
}